import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Modal
} from '@material-ui/core';
import { styleEndowment } from './styleEndowment';
import { useStateValue } from '../../context/store';
import { fingerPrintEndowment } from '../../actions/endowment-delivery-action';

function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
}

const TakeFingerprintModal = ({
  openModal,
  closeModalFinger,
  setMessage,
  message,
  requestMessage,
  typeFinger,
  getAllEndowmentDelivery
}) => {
  const classes = styleEndowment();
  const [modalStyle] = useState(getModalStyle);
  const [{dataEndowment}, dispatch] = useStateValue();

  window.document.addEventListener('myCustomEvent', handleEvent, false)
  function handleEvent(e) {
    if(e.detail){
      closeModalFinger();
      setMessage({
        description : 'Desea enviar huella?',
        textButtonSubmit : 'ACEPTAR',
        handleClick: () => handleClickFinger(e.detail),
        handleClickOut: () => handleClickClose(),
        type: "QUESTION",
        open: true,
      })
    }
  }

  const handleClickFinger = (base64) => {
    handleClickSendFingerPrint(base64);
    handleClickClose();
  }

  const handleClickSendFingerPrint = (finger) => {
    const newData = {
      data: finger,
      format: 'png',
      name: 'finger'
    };
    sendFingerPrint(newData);
  }

  const sendFingerPrint = async (info) => {
    const response = await fingerPrintEndowment(info, dataEndowment?.dataId, typeFinger);
    if(response?.status === 200 || response?.status === 201){
      const msj = 'Ingreso exitoso.'
      requestMessage(msj, 'SUCCESS', handleClickClose);
      dispatch({
        type: "DATA_ENDOWMENT",
        dataId: ''
      });
      getAllEndowmentDelivery();
    }else if(response?.status > 399 && response?.status !== 401 && response?.status !== 403){
      const msj = response?.data?.detail
        ? response?.data?.detail
        : 'Error al ingresar la huella';
      requestMessage(msj, 'WARNING', handleClickClose);
    }else{
      const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamente';
      requestMessage(msj, 'WARNING', handleClickClose);
    }
  }

  const handleClickClose = () => {
    setMessage({...message, open:false});
  }
  
    const bodyModal = (
      <div style={modalStyle} className={classes.contModalFinger}>
        <Card className={classes.card} elevation={0} >
        <CardContent className={classes.bodyModalFinger}>

          <div className={classes.contAccordionFinger}>
            
            <iframe
                title='finger print'
                src='/my-finger-print/index.html'
                //src='http://127.0.0.1:5500/UareUSampleWEB/index.html'
                width='100%'
                height='450px'
                style={{border: 'transparent'}}
            ></iframe>

            <Grid item xs={12} md={12} lg={12} style={{textAlign: 'center', marginTop: '20px'}}>
                <Button
                    variant='outlined'
                    style={{backgroundColor: 'transparent', color: '#7EBDCE'}}
                    onClick={closeModalFinger}
                >
                    Volver
                </Button>
            </Grid>
          </div>
       </CardContent>
      </Card>
      </div>
    );
  
    return (
      <div>
        <Modal
          open={openModal}
        >
          {bodyModal}
        </Modal>
      </div>
    );
}

export default TakeFingerprintModal